module.exports = __webpack_public_path__ + "img/72.4c492f30.jpg";